// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"4c2ee8ca","353":"86749d72","374":"4ad20bb2","453":"1519601c","471":"d606b2c6","595":"a4147364","604":"1ae799c1","664":"ece7debb","761":"7ef60bc1","979":"5ce0afba"}[chunkId] + ".chunk.js";
};